import React from "react";
import "./payoutsSkeleton.css";

const PayoutsLoadingSkeleton = () => {
  return (
    <div className='sl-payouts-skeleton-container'>
      {/* Header */}
      <div className='sl-payouts-skeleton-header'>
        <div className='sl-payouts-skeleton-title'></div>
        <div className='sl-payouts-skeleton-subtitle'></div>
      </div>

      {/* Stats Cards */}
      <div className='sl-payouts-skeleton-stats'>
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className='sl-payouts-skeleton-stat-card'>
            <div className='sl-payouts-skeleton-stat-icon'></div>
            <div className='sl-payouts-skeleton-stat-content'>
              <div className='sl-payouts-skeleton-stat-label'></div>
              <div className='sl-payouts-skeleton-stat-value'></div>
            </div>
          </div>
        ))}
      </div>

      {/* Referral Card */}
      <div className='sl-payouts-skeleton-referral-card'>
        <div className='sl-payouts-skeleton-referral-header'>
          <div className='sl-payouts-skeleton-referral-title'></div>
          <div className='sl-payouts-skeleton-referral-metrics'>
            <div className='sl-payouts-skeleton-metric'></div>
            <div className='sl-payouts-skeleton-metric'></div>
          </div>
        </div>
        <div className='sl-payouts-skeleton-referral-subtitle'></div>
        <div className='sl-payouts-skeleton-referral-link'></div>
        <div className='sl-payouts-skeleton-referral-buttons'>
          <div className='sl-payouts-skeleton-share-btn'></div>
          <div className='sl-payouts-skeleton-share-btn'></div>
          <div className='sl-payouts-skeleton-share-btn'></div>
        </div>
      </div>

      {/* Two Column Layout */}
      <div className='sl-payouts-skeleton-two-column'>
        {/* Pending Payments */}
        <div className='sl-payouts-skeleton-section'>
          <div className='sl-payouts-skeleton-section-header'>
            <div className='sl-payouts-skeleton-section-title'></div>
            <div className='sl-payouts-skeleton-badge'></div>
          </div>
          <div className='sl-payouts-skeleton-list'>
            {[1, 2, 3, 4, 5].map((index) => (
              <div key={index} className='sl-payouts-skeleton-list-item'>
                <div className='sl-payouts-skeleton-item-icon'></div>
                <div className='sl-payouts-skeleton-item-content'>
                  <div className='sl-payouts-skeleton-item-name'></div>
                  <div className='sl-payouts-skeleton-item-type'></div>
                  <div className='sl-payouts-skeleton-item-date'></div>
                </div>
                <div className='sl-payouts-skeleton-item-amount'></div>
              </div>
            ))}
          </div>
        </div>

        {/* Payout History */}
        <div className='sl-payouts-skeleton-section'>
          <div className='sl-payouts-skeleton-section-header'>
            <div className='sl-payouts-skeleton-section-title'></div>
            <div className='sl-payouts-skeleton-badge'></div>
          </div>
          <div className='sl-payouts-skeleton-list'>
            {[1, 2, 3, 4, 5].map((index) => (
              <div key={index} className='sl-payouts-skeleton-list-item'>
                <div className='sl-payouts-skeleton-item-check'></div>
                <div className='sl-payouts-skeleton-item-content'>
                  <div className='sl-payouts-skeleton-item-name'></div>
                  <div className='sl-payouts-skeleton-item-details'></div>
                </div>
                <div className='sl-payouts-skeleton-item-right'>
                  <div className='sl-payouts-skeleton-item-amount'></div>
                  <div className='sl-payouts-skeleton-item-status'></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayoutsLoadingSkeleton;
